export const mentoringTrainingCataloguesData = {
  Romania: [
    {
      name: 'Startarium',
      description:
        'A platform providing training, mentoring, online courses and resources for start-ups and early-stage entrepreneurs.',
      countryRegion: 'Romania',
      website: 'https://www.startarium.ro',
      contact: 'contact@startarium.ro'
    },
    {
      name: 'She Means Business Romania',
      description:
        'Training and mentoring programme supporting women entrepreneurs in developing digital, leadership and business skills, with a focus on SME growth.',
      countryRegion: 'Romania',
      website: 'https://shemeansbusiness.fb.com/ro/',
      contact: 'Facebook Romania – business@fb.com'
    },
    {
      name: 'Femeia Antreprenor – Mentoring component',
      description:
        'Mentoring and capacity-building component linked to the national programme for women entrepreneurs, supporting business development and access to finance.',
      countryRegion: 'Romania',
      website: 'https://www.imm.gov.ro/femeia-antreprenor/',
      contact: 'antreprenoriat@imm.gov.ro'
    },
    {
      name: 'Innovation Labs',
      description:
        'Pre-accelerator programme offering mentoring, training and validation support for innovative and technology-based start-ups.',
      countryRegion: 'Romania',
      website: 'https://innovationlabs.ro',
      contact: 'office@innovationlabs.ro'
    }
  ],
  Moldova: [
    {
      name: 'ODA Entrepreneurship Education & Training Courses',
      description:
        'Training courses aimed at developing entrepreneurial skills, including sessions on SME management, environmental management and business modernisation; supported by expert providers under the ODA programme.',
      countryRegion: 'Moldova',
      website: 'https://www.oda.md/en/suport-antreprenorial-en/oda-instruiri-en',
      contact: 'info@oda.md'
    },
    {
      name: 'Tulip Business Incubator 2.0',
      description:
        'Incubator and mentoring programme for young entrepreneurs combining practical business training, mentoring sessions and access to grants.',
      countryRegion: 'Moldova',
      website:
        'https://e-tineret.md/en/tulip-business-incubator-2-0-training-and-funding-opportunity-for-young-entrepreneurs/',
      contact: 'procurari@expert-grup.org'
    },
    {
      name: 'AFAM Business Mentoring for Women',
      description:
        'Mentoring programme focused on women in business, with courses on leadership, financial management, digitalisation & resilience and personalised mentoring support.',
      countryRegion: 'Moldova',
      website: 'https://afam.md/en/proiecte/programul-de-mentorat-in-afaceri-pentru-femei-business-mentoring',
      contact: ''
    }
  ],
  Germany: [
    {
      name: 'EIT Climate-KIC Accelerator Germany',
      description:
        'EU-funded accelerator program in several German locations (e.g. Berlin, Munich) for early-stage cleantech start-ups. Offers 3-stage business coaching, up to €95k equity-free funding, and international network access.',
      countryRegion: 'Germany',
      website: 'https://www.climate-kic.org/programmes/entrepreneurship/climate-kic-accelerator/',
      contact: ''
    },
    {
      name: 'Circular Valley Accelerator',
      description:
        'International accelerator (Wuppertal) focusing on circular economy start-ups. Provides a 3-month program with mentoring, industry partner access (especially in waste/recycling sectors), and a grant of ~€50k. Public-private funded.',
      countryRegion: 'Germany',
      website: 'https://circular-valley.org',
      contact: 'accelerator@circular-valley.org'
    },
    {
      name: 'Circular Together Incubator',
      description:
        'Six-month incubator by Impact Hub Berlin (supported by Berlin Senate) for impact start-ups in circular economy. Offers a €2k/month stipend per founder, co-working, tailored expert mentorship, and partnership-building opportunities.',
      countryRegion: 'Germany',
      website: 'https://berlin.impacthub.net/circular-together/',
      contact: 'programs@impacthub.berlin'
    },
    {
      name: 'AXEL – Energy Accelerator',
      description:
        'Specialized accelerator for energy and green technology start-ups (Karlsruhe). Provides a 3-stage program (Ignition, Spark, and Xpress) with technical coaching, industry mentors, free office space, and investor matchmaking. Supported by the state and industry.',
      countryRegion: 'Germany',
      website: 'https://axel.energy',
      contact: 'team@axel.energy'
    },
    {
      name: 'Social Impact Lab Stuttgart (Green & Social Start-ups)',
      description:
        'Incubation hub offering a 6-month coaching and training program for social and sustainable business ideas. Provides workshops, mentoring, co-working space, and access to a network of experts and investors. Participation is free due to public and foundation funding.',
      countryRegion: 'Germany',
      website: 'https://stuttgart.socialimpactlab.eu',
      contact: 'stuttgart@socialimpact.eu'
    },
    {
      name: 'Start-up BW (State Initiative for Start-ups)',
      description:
        'Central platform by the state of Baden-Württemberg offering bundled access to start-up accelerators, mentoring, funding programs and female entrepreneurship initiatives. Gateway to public start-up support across sectors and regions.',
      countryRegion: 'Germany',
      website: 'https://www.startupbw.de',
      contact: 'startup@wm.bwl.de'
    }
  ],
  Serbia: [
    {
      name: 'S4AI_HUB – Serbian European Digital Innovation Hub',
      description:
        'National digital innovation hub providing mentoring, consulting, and innovation support to SMEs and public institutions in digital transformation, AI adoption, and smart specialisation priorities (RIS3). Includes mentoring through programs like Innovation Camp for Digital Transformation.',
      countryRegion: 'Serbia',
      website: 'http://s4ai.rs/',
      contact: 'info@s4ai.hub'
    },
    {
      name: 'CIPS – Capital Innovation Point Serbia (EDIH)',
      description:
        'EU-supported digital innovation hub offering mentoring, training, and technical support to startups and SMEs for digital and smart specialisation-based innovation and market expansion.',
      countryRegion: 'Serbia',
      website: 'https://ntpark.rs/en/edih-2/',
      contact: 'project.cips@ntpark.rs'
    },
    {
      name: 'GreenUp Accelerator Program',
      description:
        'Accelerator program focused on green and circular economy solutions, offering intensive mentoring, workshops, and investor connections for startups developing sustainable and climate-related innovations.',
      countryRegion: 'Serbia',
      website: 'https://www.icthub.rs/en/article/the-greenup-accelerator-program',
      contact: 'info@icthub.rs'
    },
    {
      name: 'Western Balkans Circular Economy Hub – Twin Green & Digital Programme',
      description:
        'Regional network providing mentoring, advisory services, and capacity building for companies transitioning to circular, green, and digital business models; includes stakeholder networking and project support.',
      countryRegion: 'Serbia',
      website: 'https://wbcirculareconomy.com/',
      contact: 'regionalcehub@gmail.com'
    },
    {
      name: 'Center for Digital Transformation (CDT) – Mentoring Programme',
      description:
        'Mentoring-based support for SMEs undergoing digital transformation, with expert mentors guiding companies through adoption of digital tools and new business models',
      countryRegion: 'Serbia',
      website: 'https://cdt.org.rs/en',
      contact: 'office@cdt.org.rs'
    },
    {
      name: 'SME HUB (ICT Hub + SDC)',
      description:
        'Program supporting SMEs through advisory services, capacity building, and mentoring to improve competitiveness, supply chain integration, and business transformation.',
      countryRegion: 'Serbia',
      website: 'https://smehub.rs/en',
      contact: 'info@icthub.rs'
    }
  ],
  Croatia: [
    {
      name: 'Enterprise Europe Network – Mentoring & Advisory Services',
      description:
        'Mentoring, advisory and training services for SMEs and startups in innovation, digital transition, internationalisation and sustainability, incl. circular business models.',
      countryRegion: 'Croatia',
      website: 'https://een.ec.europa.eu',
      contact: ''
    },
    {
      name: 'HAMAG-BICRO Mentoring & Education Programmes',
      description:
        'Structured mentoring, training and acceleration programmes for startups and SMEs (digitalisation, innovation, women entrepreneurship, access to finance).',
      countryRegion: 'Croatia',
      website: 'https://hamagbicro.hr',
      contact: 'info@hamagbicro.hr'
    },
    {
      name: 'Women Entrepreneurship Support Programme (HAMAG-BICRO)',
      description:
        'Mentoring, education and financial literacy programmes specifically designed for women entrepreneurs and women-led SMEs.',
      countryRegion: 'Croatia',
      website: 'https://hamagbicro.hr',
      contact: 'info@hamagbicro.hr'
    },
    {
      name: 'Croatian Employment Service – Training & Reskilling Catalogues',
      description:
        'National catalogue of training and upskilling programmes (digital skills, green skills, entrepreneurship), incl. vouchers for adult education.',
      countryRegion: 'Croatia',
      website: 'https://mjere.hzz.hr',
      contact: ''
    },
    {
      name: 'Digital Skills Training Programmes (Digitalna Hrvatska)',
      description:
        'Training catalogues and initiatives aimed at improving digital skills of citizens, entrepreneurs and public sector.',
      countryRegion: 'Croatia',
      website: 'https://digitalna.hr',
      contact: 'info@digitalna.hr'
    },
    {
      name: 'Technology Parks & Business Incubators Mentoring Programmes',
      description:
        'Mentoring and training catalogues offered by technology parks and incubators (startup mentoring, digital transformation, green and circular innovation).',
      countryRegion: 'Croatia',
      website: 'https://gov.hr',
      contact: 'Local technology parks'
    },
    {
      name: 'HGK Education & Mentoring Programmes',
      description:
        'Training catalogues, mentoring schemes and lifelong learning programmes for entrepreneurs, including digitalisation and sustainability topics.',
      countryRegion: 'Croatia',
      website: 'https://www.hgk.hr',
      contact: 'edukacija@hgk.hr'
    },
    {
      name: 'Women in Adria Mentoring & Education Programmes',
      description: 'Mentoring, peer-learning and training programmes for women entrepreneurs and professionals.',
      countryRegion: 'Croatia',
      website: 'https://womeninadria.com',
      contact: 'info@womeninadria.com'
    },
    {
      name: 'Startup Academy Croatia (various providers)',
      description:
        'Short-term training and mentoring programmes for early-stage startups, focusing on business development and digital skills.',
      countryRegion: 'Croatia',
      website: 'https://crostartup.com',
      contact: 'info@crostartup.com'
    }
  ],
  Austria: [
    {
      name: 'KMU.Digital',
      description:
        'KMU.DIGITAL KMU.DIGITAL is a highly successful Austrian support initiative that provides small and medium-sized enterprises (SMEs) with financial grants for professional consulting and the implementation of digital projects. The program covers key areas such as e-commerce, social media, IT security, and the automation of business processes. It helps companies assess their digital maturity and provides a structured pathway to modernize their operations. This initiative is a cornerstone for the digital transition of SMEs within the framework of national innovation strategies.',
      countryRegion: 'Austria',
      website: 'KMU.DIGITAL',
      contact: ''
    },
    {
      name: 'Female Founders “Grow F” Accelerator',
      description:
        'Grow F Accelerator (by Female Founders) Grow F is a leading European acceleration program specifically designed for female-led, venture-scale startups to reach investment readiness. The program provides gender-diverse founding teams with access to a high-level network of mentors, investors, and industry experts over a three-month period. It focuses on scaling tech-driven business models and preparing entrepreneurs for successful fundraising rounds. For we.circular, it represents the ideal platform for high-growth startups in the digital and circular economy sectors.',
      countryRegion: 'Austria',
      website: 'FFB 2026',
      contact: ''
    },
    {
      name: 'KMU.Digital & Green',
      description:
        'KMU.DIGITAL & GREEN Expanding on the original digital initiative, KMU.DIGITAL & GREEN specifically supports SMEs in leveraging digital technologies to achieve ecological sustainability. The program funds consulting and investments that use digital tools to reduce carbon footprints, optimize resource efficiency, or transition to circular business models. It bridges the gap between the twin transition of digitalization and sustainability, making it a perfect reference for the we.circular project goals. By integrating "Green" objectives, it empowers companies to become more resilient and environmentally responsible through technological innovation.',
      countryRegion: 'Austria',
      website: 'KMU.DIGITAL & GREEN',
      contact: ''
    },
    {
      name: 'FEMcademy',
      description: 'Business mentoring for women in business',
      countryRegion: 'Austria',
      website: 'FEMcademy - WKO',
      contact: ''
    },
    {
      name: 'Certificate Programme Circular Economy & Innovation',
      description:
        'The Circular Economy & Innovation Certificate Programme provides participants with the necessary practical knowledge to understand aspects of the circular economy as a whole and to apply them strategically and conceptually in their context. Graduates of this certificate programme have up-to-date and unique know-how in the field of the circular economy that goes far beyond the waste management and recycling topics previously understood by the term, and also demonstrates the high innovation potential for companies. This certificate programme combines transdisciplinary knowledge acquisition with a high degree of practical orientation and offers an overview of both the latest scientific findings and the current regulatory and legal framework.',
      countryRegion: 'Austria',
      website: 'CP Kreislaufwirtschaft & Innovation - FH des BFI Wien',
      contact: ''
    }
  ],
  Bulgaria: [
    {
      name: 'EWA Bulgaria (Empowering Women in Agrifood – EIT Food)',
      description:
        'A 6-month programme supporting women entrepreneurs with an idea or early-stage business in the agrifood sector. Includes business training, 1:1 mentoring, networking, pitching events, and financial awards. Implemented in Bulgaria by RAPIV as EIT Food Hub.',
      countryRegion: 'Bulgaria',
      website:
        'https://www.eitfood.eu/projects/ewa-empowering-women-in-agrifood?utm_source=chatgpt.com https://www.rapiv.org/bg/blog_more/ewa-bulgaria-2024/?utm_source=chatgpt.com',
      contact: 'RAPIV (EIT Food Hub Bulgaria): office@rapiv.org'
    },
    {
      name: 'Ecosys4you – Online Mentoring & Entrepreneurship Support',
      description:
        'A EU-funded entrepreneurial education and mentoring programme under Horizon Europe designed for young students and early-stage entrepreneurs. It connects entrepreneurial ecosystems in the three regions and offers online mentoring, business consulting, networking, skills development tasks, and opportunities to work on business ideas with experienced entrepreneurs and mentors. Participation is usually free of charge for selected mentees aged ~18–35.',
      countryRegion: 'Bulgaria',
      website: 'https://www.ecosys4you.eu/participate/mentoring/',
      contact: 'RAPIV (hosting partner for Bulgaria): office@rapiv.org'
    },
    {
      name: 'AWE (Academy for Women Entrepreneurs) – Bulgaria (Smart Varna Foundation)',
      description:
        'Global initiative of the U.S. Department of State supporting women entrepreneurs through training, mentoring, and networking. In Bulgaria, editions are implemented with local partners such as Smart Varna Foundation.',
      countryRegion: 'Bulgaria',
      website: 'https://smartvarna.org/',
      contact: 'info@smartvarna.org'
    },
    {
      name: 'Smart Lady by Fibank',
      description:
        'Programme by First Investment Bank (Fibank) supporting women entrepreneurs through financial products, training, mentoring events, and networking.',
      countryRegion: 'Bulgaria',
      website: 'https://www.fibank.bg',
      contact: 'call@fibank.bg'
    },
    {
      name: 'She’s Next by Visa',
      description:
        'Global Visa initiative empowering women entrepreneurs through mentoring, business training, visibility, and grant funding. In Bulgaria, implemented in partnership with the Ladies Forum Association. Includes a mentoring programme for finalists and financial awards for top businesses.',
      countryRegion: 'Bulgaria',
      website: 'https://www.visabg.com/shes-next.html',
      contact: 'https://ladiesforum.info/contacts'
    },
    {
      name: 'Business Lady Club',
      description:
        'A mentoring and networking programme focused on women entrepreneurs and professionals, supporting business growth, leadership skills, and community building through mentoring sessions and events.',
      countryRegion: 'Bulgaria',
      website: 'https://businesslady.club/index.php',
      contact: 'office@business-ladies-club.com'
    },
    {
      name: 'Mentorite BG',
      description:
        'A 6-month national mentoring programme for women entrepreneurs, providing structured mentoring, group sessions, and access to a professional community.',
      countryRegion: 'Bulgaria',
      website: 'https://mentorite.bg',
      contact: 'info@mentorite.bg'
    },
    {
      name: 'DEA Accelerate (Women-focused cohorts)',
      description:
        'Accelerator programme supporting women-led startups through mentoring, business development training, investor access, and demo days.',
      countryRegion: 'Bulgaria',
      website: 'https://www.deaaccelerate.com',
      contact: 'info@deaaccelerate.com'
    },
    {
      name: 'Innovation Starter Accelerator',
      description:
        'Educational accelerator for pre-seed startups, offering mentoring, structured business education, and access to a startup and investor network.',
      countryRegion: 'Bulgaria',
      website: 'https://accelerator.bg/?utm_source=chatgpt.com',
      contact: 'office@innovationstarter.bg'
    },
    {
      name: 'Accelerator Startup Sofia',
      description:
        'Municipal accelerator programme providing mentoring, training, grants, and ecosystem access for startups, implemented by Invest Sofia.',
      countryRegion: 'Bulgaria',
      website: 'https://investsofia.com',
      contact: 'contact@investsofia.com'
    },
    {
      name: 'Start It Smart – Pre-Accelerator',
      description:
        'A 10-week pre-accelerator programme offering intensive training and mentoring for early-stage entrepreneurs and startup teams.',
      countryRegion: 'Bulgaria',
      website: 'https://www.startitsmart.com/bg/',
      contact: 'info@startitsmart.com'
    }
  ],
  Slovenia: [
    {
      name: 'Startup Plus Programme – Mentoring & Training',
      description:
        'Comprehensive support programme for innovative Slovenian start‑ups, combining financial incentives with an intensive mentoring system (120+ mentors) and over 10 specialised training programmes focused on global growth, acceleration, corporate collaboration and internationalisation.',
      countryRegion: 'Slovenia',
      website: 'https://startup-plus.podjetniskisklad.si/en/about-the-programme/',
      contact: 'info@podjetniskisklad.si'
    },
    {
      name: 'DIH Slovenia – Digital Skills & Transformation Services',
      description:
        'National one‑stop‑shop offering free training for SMEs in digitalisation, Industry 4.0, digital competencies, best practices exchange, workshops and tailored support to accelerate digital transformation.',
      countryRegion: 'Slovenia',
      website: 'https://dihslovenia.si/en/about-us',
      contact: 'info@dihslovenia.si'
    },
    {
      name: 'Digitalisation in Business – Catalogue of Mentors & Training',
      description:
        'Government programme supporting digital transformation of companies; includes catalogues of digital competencies, mentors, consultants, and training content to help SMEs adopt ICT, improve digital skills and implement digital transformation measures.',
      countryRegion: 'Slovenia',
      website: 'https://www.gov.si/en/topics/digitalisation-in-business/',
      contact: 'Ministry of the Economy, Tourism and Sport (via GOV.SI contact form)'
    },
    {
      name: 'Mentoring Training Course – The Knowledge Academy',
      description:
        'Professional “Train the Trainer” mentoring course covering mentor roles, session structuring, action plans, leadership skills, communication skills and continuous professional development. Suitable for HR, managers, coaches and educators.',
      countryRegion: 'Slovenia',
      website: 'https://www.theknowledgeacademy.com/si/courses/train-the-trainer/mentoring-skills/',
      contact: 'info@theknowledgeacademy.com'
    },
    {
      name: 'DIS4SME – Digital Skills for SMEs (Training in Data Interoperability)',
      description:
        'Training programme for SMEs focused on digital transformation, data interoperability, location data management (INSPIRE, OGC, ISO standards), and practical courses for sectors like agriculture, mobility, and urban planning.',
      countryRegion: 'Slovenia',
      website: 'https://advancedskills.eu/countries/slovenia/',
      contact: 'info@advancedskills.eu (programme-level contact)'
    }
  ],
  Czechia: [
    {
      name: 'Women in Tech Academy (CZ)',
      description:
        'Structured training and mentoring programme for women founders and professionals in technology and digital entrepreneurship',
      countryRegion: 'Czechia',
      website: 'https://women-in-tech.org/women-in-tech-academy/',
      contact: ''
    },
    {
      name: 'Czechitas – Digital Academies',
      description:
        'Intensive digital and IT training programmes (data, testing, development, digital tools) enabling women to start or scale digital businesses.',
      countryRegion: 'Czechia',
      website: 'https://www.czechitas.cz/',
      contact: 'info@czechitas.cz'
    },
    {
      name: 'Holky z byznysu – Mentoring Programmes',
      description:
        'Practical mentoring and training programmes for early-stage women entrepreneurs, freelancers and founders.',
      countryRegion: 'Czechia',
      website: 'https://www.holkyzbyznysu.cz/',
      contact: 'ahoj@holkyzbyznysu.cz'
    },
    {
      name: 'CzechInvest – Startup Acceleration & Mentoring',
      description:
        'Structured acceleration and mentoring programmes for startups and scale-ups (incl. women-led teams), focused on business development and access to finance.',
      countryRegion: 'Czechia',
      website: 'https://czechinvest.gov.cz/',
      contact: 'fdi@czechinvest.gov.cz'
    },
    {
      name: 'TA CR – Knowledge Transfer & Innovation Training',
      description:
        'Training and mentoring linked to applied research projects, technology transfer and commercialisation of R&D results.',
      countryRegion: 'Czechia',
      website: 'https://tacr.gov.cz/',
      contact: 'info@tacr.cz'
    },
    {
      name: 'P-PINK',
      description:
        'Regional innovation hub and incubator supporting start-ups, entrepreneurs and innovators through mentoring, training programmes, incubation services and networking, with a strong link to regional smart specialisation priorities.',
      countryRegion: 'Czechia',
      website: 'https://p-pink.cz/',
      contact: 'info@p-pink.cz'
    },
    {
      name: 'Lipo.ink',
      description:
        'Regional innovation centre in the Liberec Region providing business incubation, mentoring, acceleration programmes and innovation support for start-ups, SMEs and creative industries, including digital and green solutions.',
      countryRegion: 'Czechia',
      website: 'https://lipo.ink/cs',
      contact: 'recepce@lipo.ink'
    },
    {
      name: 'Nastartuj to!',
      description:
        'National start-up competition and mentoring programme offering training, expert mentoring and pitching opportunities to early-stage entrepreneurs to help them validate ideas and launch viable businesses.',
      countryRegion: 'Czechia',
      website: 'https://nastartujto.sk/cs/',
      contact: 'info@nastartujto.sk'
    },
    {
      name: 'Startink',
      description:
        'Czech student-focused entrepreneurship programme and competition that supports young innovators and start-up teams through mentoring, business training and exposure to investors and industry experts.',
      countryRegion: 'Czechia',
      website: 'https://startink.cz/',
      contact: 'start@startink.cz'
    },
    {
      name: 'Startovárna MSIC',
      description:
        'An incubation and acceleration programme run by the Moravian-Silesian Innovation Centre, providing intensive mentoring, business development support and capacity building for start-ups and innovative SMEs in the Moravian-Silesian Region.',
      countryRegion: 'Czechia',
      website: 'https://ms-ic.cz/sluzby/startovarna/',
      contact: 'tereza.skoumalova@ms-ic.cz'
    },
    {
      name: 'DoToho!',
      description:
        'An entrepreneurship and mentoring programme designed to turn early-stage ideas into viable businesses through structured training, expert mentoring, peer learning and access to a strong entrepreneurial network, with a focus on innovation and impact.',
      countryRegion: 'Czechia',
      website:
        'https://dotoho.pro/jak-to-funguje?gad_source=1&gad_campaignid=21200443865&gbraid=0AAAAAo1shMzkgdX439hjSIEPQsx2OG0wN&gclid=Cj0KCQjw6bfHBhDNARIsAIGsqLhzueoalUyhe7RlgJmai8s981gEc1c9zIh5ijhi51-y6lmAF1bCdqEaAkl6EALw_wcB',
      contact: 'marek.hodek@opero.cz'
    }
  ],
  'Slovak republic': [
    {
      name: 'Ready To Lead Academy (Ženský algoritmus)',
      description:
        'A structured leadership and personal development programme designed for women to build leadership, digital confidence, personal branding, and effective use of technology; includes online course modules, group sessions, mentoring and a certificate.',
      countryRegion: 'Slovakia',
      website: 'https://www.zenskyalgoritmus.sk/',
      contact: 'petra.krizovenska@zenskyalgoritmus.sk'
    },
    {
      name: 'RE‑FEM Online Course (Slovak)',
      description:
        'Free online course with modules on digital transformation, finance & innovation, sustainability and resilience for female entrepreneurs - includes skills for digital marketing, AI, financing, circular economy and personal resilience.',
      countryRegion: 'Slovakia',
      website: 'https://refem.eu/refem-online-course-slovak/?utm',
      contact: 'https://refem.eu/contact-us/'
    },
    {
      name: 'Aj Ty v IT - Women & IT Events',
      description:
        'Ongoing IT and digital skills training events (Excel, SQL, Power BI, UX/UI, AI, cybersecurity, coding) targeted at women and the wider community, supports digital literacy and transformation skills.',
      countryRegion: 'Slovakia',
      website: 'https://ajtyvit.sk/podujatia/?utm',
      contact: 'info@ajtyvit.sk'
    },
    {
      name: 'Zelená cirkulárna akadémia (Green Circular Academy)',
      description:
        'Educational programme by INCIEN providing structured education on circular economy principles and applications, linking sustainability with practice for professionals and entrepreneurs.',
      countryRegion: 'Slovakia',
      website: 'https://www.incien.sk/projekty-sk/vzdelavanie/zelena-cirkularna-akademia-2/?utm',
      contact: 'https://www.incien.sk/kontakty/'
    },
    {
      name: 'Top Centrum Podnikateliek - Training & Events',
      description:
        'Networking and professional development community for women entrepreneurs, organizes events, workshops and mentoring opportunities focused on personal and business growth.',
      countryRegion: 'Slovakia',
      website: 'https://www.tcpsk.com/?utm',
      contact: 'info@tcpsk.com'
    },
    {
      name: 'Úspešné ženy (Successful Women Association)',
      description:
        'Organization offering training, mentoring, webinars and support networks for women in business, personal development and leadership.',
      countryRegion: 'Slovakia',
      website: 'https://www.uspesnezeny.sk/',
      contact: 'zdruzenie@zpam.sk'
    },
    {
      name: 'Akčné ženy (Active Women)',
      description:
        'Community offering webinars, coaching and training across skills, digital marketing, finance, leadership and work‑life balance for women seeking personal and business growth.',
      countryRegion: 'Slovakia',
      website: 'https://akcnezeny.sk/',
      contact: 'info@akcnezeny.sk'
    },
    {
      name: '3E - Institute for Environmental Research & Education',
      description:
        'Educational institute offering environmental & sustainability education including activities tied to circular economy and sustainable development (e.g., summer schools, workshops).',
      countryRegion: 'Slovakia',
      website: 'https://3e-institut.sk/',
      contact: 'info@3e-institut.sk'
    },
    {
      name: 'Mini Tech MBA - IT Academy for Women',
      description:
        'Mini Tech MBA programme focused on improving digital and technological business leadership skills for women, including digital strategy and tech adoption in business.',
      countryRegion: 'Slovakia',
      website: 'https://minitechmba.org/',
      contact: 'info@minitechmba.org'
    },
    {
      name: 'E‑ženy Community & Workshops (E‑klub)',
      description:
        'Online club offering workshops, webinars, Q&A sessions, and peer support for women, particularly virtual assistants and online entrepreneurs, with training on online business and the use of digital tools.',
      countryRegion: 'Slovakia',
      website: 'https://virtualneasistentky.eu/e-klub',
      contact: 'via website'
    },
    {
      name: 'Hekima - Women Empowerment & Youth Training',
      description:
        'Organisation focused on women empowerment, leadership, and community change through training, events, and support programmes (includes capacity building for women leaders).',
      countryRegion: 'Slovakia',
      website: 'https://www.hekima.sk/',
      contact: 'via website'
    }
  ],
  'Bosnia and Herzegovina': [
    {
      name: 'Program obuke i mentorstva – BiHub – women & green entrepreneurship',
      description:
        'Training series on business management, financial planning, green business models, marketing and pitching for women entrepreneurs focused on sustainable business practices and green innovation.',
      countryRegion: 'Bosnia and Herzegovina',
      website: 'https://bihhub.org/',
      contact: 'info@cem.ba'
    },
    {
      name: 'SEDEP – Education & Mentoring for Digital and Green Transition',
      description:
        'Provides education, mentoring and financial support opportunities for women and businesses to develop sustainable digital and green business models and skills as part of broader economic development efforts.',
      countryRegion: 'Bosnia and Herzegovina',
      website: 'https://digigreen.ba/en/empowering-women-through-the-digital-and-green-transition/',
      contact: 'info@digigreen.ba'
    },
    {
      name: 'Rise – Green & Digital Support for Women Entrepreneurs (CRP BiH)',
      description:
        'Programme providing tailored mentoring, training and capacity building for women business owners engaged in green and digital economic activities; includes practical sessions and networking.',
      countryRegion: 'Bosnia and Herzegovina',
      website: 'https://crp.ba/programi-podrske-za-zene-poduzetnice-u-bih/',
      contact: '00 387 61214073'
    },
    {
      name: 'Start-up Program for Women – “Strong Woman, Strong Business”',
      description:
        'Startup training and mentoring over several months; includes business idea coaching, mentoring support and potential seed funding for women entrepreneurs.',
      countryRegion: 'Bosnia and Herzegovina',
      website: 'https://investinbrod.ba/call-for-startup-program-for-women/',
      contact: 'venesa.klempic@zenezazene.ba'
    },
    {
      name: 'Udruženje poslovnih žena u BiH – Workshops & Training',
      description:
        'Regular training events and mentoring focused on business development, finance and networking for women entrepreneurs in various sectors.',
      countryRegion: 'Bosnia and Herzegovina',
      website: 'https://poduzetna.ba/upz/',
      contact: '00 387 62532047'
    }
  ],
  Hungary: [
    {
      name: 'Personal Entrepreneur Mentoring Program',
      description:
        'Free of charge, personalized mentoring and complex development program for micro and small enterprises, with a special focus on female entrepreneurs (as well).',
      countryRegion: 'Hungary',
      website: 'https://seed.hu/szintlepes/',
      contact: 'seed@seed.hu'
    },
    {
      name: 'AWE Hungary – Academy for Women Entrepreneurs',
      description:
        "A multi-month women/'s entrepreneurship promotion program that offers online business development training, incubation, networking and continuous mentoring for female entrepreneurs.",
      countryRegion: 'Hungary',
      website: 'https://awehungary.com/',
      contact: 'nincs kontakt hozzá'
    },
    {
      name: 'Impact Hub Budapest – Women Entrepreneurs Program',
      description:
        'Intensive Business Development Program for Women (Idea or Early Stage) - Early-stage, which provides practical knowledge, mentoring and networking with women entrepreneurs.',
      countryRegion: 'Hungary',
      website: 'https://budapest.impacthub.net/incorpora/',
      contact: 'incorpora.budapest@impacthub.net'
    },
    {
      name: 'Egyenlítő Alapítvány – Mentorprogram',
      description:
        "A multi-month, structured mentor pair program (mentor-mentee) that supports women/'s professional advancement and leadership/career development (also with entrepreneurial relevance).",
      countryRegion: 'Hungary',
      website: 'https://egyenlitoalapitvany.org/mentorprogram-2026/',
      contact: 'info@egyenlitoalapitvany.org'
    },
    {
      name: 'Hiventures-Startup mentoring and acceleration (incl. women-focused initiatives)',
      description: 'Hiventures Venture Capital Fund Management',
      countryRegion: 'Hungary',
      website: 'https://www.hiventures.hu/en/',
      contact: 'info@hiventures.hu'
    },
    {
      name: 'Enterprise Europe Network Hungary - SME internationalisation mentoring and advisory services',
      description: 'Enterprise Europe Network Hungary',
      countryRegion: 'Hungary',
      website: 'https://een.ec.europa.eu/',
      contact: 'https://een.ec.europa.eu/local-contact-points/hu'
    },
    {
      name: 'Design Terminal - Innovation and business acceleration training',
      description: 'Design Terminal - Innovation and business acceleration training',
      countryRegion: 'Hungary',
      website: 'https://designterminal.org/en/active-programs',
      contact: 'https://konzultacio.designterminal.org/'
    },
    {
      name: 'Hungarian Chamber of Commerce and Industry - SME business development and export mentoring',
      description: 'Hungarian Chamber of Commerce and Industry - SME business development and export mentoring',
      countryRegion: 'Hungary',
      website: 'https://mkik.hu/kozeppontban-a-vallalkozo',
      contact: 'mkik@mkik.hu'
    },
    {
      name: 'Women in Technology Association Hungary - Women in tech mentoring, workshops and networking',
      description: 'Women in Technology Association Hungary - Women in tech mentoring, workshops and networking',
      countryRegion: 'Hungary',
      website: 'https://nokatud.hu/',
      contact: 'hello@nokatud.hu'
    },
    {
      name: 'Nők a neten',
      description:
        'Mission is to bring the online world closer to women who want their businesses to deliver the value, knowledge, and experience they want to share with the people who are looking for it.',
      countryRegion: 'Hungary',
      website: 'https://nokaneten.hu/kurzusok/',
      contact: 'https://nokaneten.hu/kapcsolat/'
    },
    {
      name: 'Modern Vállalkozások Program 2.0',
      description:
        'Preparation for digitization, development of ICT tool use - free of charge mentoring from the Hungarian Chamber of Commerce and Industry',
      countryRegion: 'Hungary',
      website: 'https://vallalkozzdigitalisan.mkik.hu/',
      contact: 'vallalkozzdigitalisan@mkik.hu'
    },
    {
      name: 'Skool',
      description: 'Digital skills development for girls',
      countryRegion: 'Hungary',
      website: 'https://www.skool.org.hu/',
      contact: 'hello@skool.org.hu'
    }
  ]
}
